import React from "react";

const Form = React.lazy(() => import("../pages/category/Form"));
const Table = React.lazy(() => import("../pages/category/Table"));
const Form1 = React.lazy(() => import("../components/Form"));


const routes = [
    {
        path: "/admin/category/create",
        element: <Form />
    },
    {
        path: "/admin/categories",
        element: <Table />
    },
    {
        path: "/about",
        element: <Form1 />
    }
];

export default routes;